import { BaseTable, Loading, TableHeader } from "components";
import { useLargeExpansese } from "../../utils";
import moment from "moment";
import { convertNumber } from "utils";

export function Expenses(props: {
    month?: string | undefined,
    year?: string | undefined,
    location_id?: string
}) {

    const { data, loading } = useLargeExpansese({
        date: `${props.year}${props.month}`,
        location_id: props.location_id
    })

    const startMonth = moment().startOf("year").format("MMM");
    const endMonth = moment(`${props.year}${props.month}`).format("MMM YYYY");
    const endBeforeYear = moment(`${props.year}${props.month}`).subtract(1, "year").format("MMM YYYY");

    return (
        <BaseTable>
            <TableHeader>
                <tr>
                    <th>Largest expenses</th>
                    <th>{startMonth} - {endMonth}</th>
                    <th>{startMonth} - {endBeforeYear}</th>
                </tr>
            </TableHeader>
            <tbody>
                {loading || !data.length
                    ?
                    <tr>
                        <td colSpan={3} className="text-center">
                            <Loading loading={loading} errorText={loading ? "" : "No data available"} />
                        </td>
                    </tr>
                    : (
                        data.map((item, key) => (
                            <tr key={key}>
                                <td>{item.coa_name}</td>
                                <td className="text-right">{item.current_balance ? convertNumber(item.current_balance).intoCurrency : "0"}</td>
                                <td className="text-right">{item.balance_before ? convertNumber(item.balance_before).intoCurrency : "0"}</td>
                            </tr>
                        ))
                    )}
            </tbody>
        </BaseTable>
    )
}